import React from 'react';

import { useCurrentOrgName } from '@hcs/auth';
import { useUserIsSelfService } from '@hcs/auth';
import { Switch } from '@hcs/design-system';
import { MenuItem } from '@hcs/design-system';
import { BuildingIcon, EditIcon } from '@hcs/design-system';
import { usePatchReportPreferencesForOrg } from '@hcs/huell';
import { useReportPreferencesForOrg } from '@hcs/huell';

import styles from './OrgReportPreferences.module.css';

const dataHcName = 'intra-org-report-access-control';
export const IntraOrgReportAccessControl = () => {
  const { isFetched, data: orgReportPrefs } = useReportPreferencesForOrg();
  const { mutate: patchOrgPrefs } = usePatchReportPreferencesForOrg();
  const { data: orgName } = useCurrentOrgName();
  const { data: isSelfService } = useUserIsSelfService();
  const value = orgReportPrefs?.preferences?.intraOrgReportAccess || 'editable';
  if (isSelfService) {
    return <span />;
  }
  return (
    <>
      <MenuItem
        dataHcName={`${dataHcName}-visibility`}
        Icon={BuildingIcon}
        label={`Visibility within ${orgName}`}
        description={`Allow ${orgName} users to see reports created by other ${orgName} users. Changing this setting effects previously created reports.`}
        contentRight={
          isFetched &&
          patchOrgPrefs && (
            <div className={styles.Switch}>
              <Switch
                switchOffOption={{
                  value: 'owner-only',
                  dataHcName: `${dataHcName}-ownerOnly`,
                }}
                switchOnOption={{
                  value: 'visible',
                  dataHcName: `${dataHcName}-visible`,
                }}
                dataHcName={`${dataHcName}-switch`}
                value={value === 'owner-only' ? value : 'visible'}
                onChange={(value) => {
                  patchOrgPrefs([
                    {
                      op: 'add',
                      path: '/intraOrgReportAccess',
                      value,
                    },
                  ]);
                }}
              />
              <div className={styles.SwitchLabel}>
                {value === 'owner-only' ? 'Disabled' : 'Enabled'}
              </div>
            </div>
          )
        }
      />
      <MenuItem
        dataHcName={`${dataHcName}-editing`}
        Icon={EditIcon}
        label={`Editing within ${orgName}`}
        description={`Allow ${orgName} users to edit reports created by other ${orgName} users. Changing this setting effects previously created reports.`}
        contentRight={
          isFetched &&
          patchOrgPrefs && (
            <div className={styles.Switch}>
              <Switch
                switchOffOption={{
                  value: 'visible',
                  dataHcName: `${dataHcName}-visible`,
                }}
                switchOnOption={{
                  value: 'editable',
                  dataHcName: `${dataHcName}-editable`,
                }}
                dataHcName={`${dataHcName}-switch`}
                value={value === 'editable' ? value : 'visible'}
                onChange={(value) => {
                  patchOrgPrefs([
                    {
                      op: 'add',
                      path: '/intraOrgReportAccess',
                      value,
                    },
                  ]);
                }}
              />
              <div className={styles.SwitchLabel}>
                {value === 'editable' ? 'Enabled' : 'Disabled'}
              </div>
            </div>
          )
        }
      />
    </>
  );
};
